import {IVariableParams, VariableAbstract} from "./VariableAbstract";
import {ICompanySyncstep, IdName, TBaseOrObservableType, TRouteId} from "../../index";
import {TServiceName, TServiceParameters} from "../../constants/ApiServices";
import {getHash} from "../../constants/RouteDefinitions";
import {getAnyValue} from "../../util/misc";
import {nsTooltip} from "../../util/nsTooltip";
import {nsSync} from "../../util/nsSync";

export {template} from "./VariableAbstract"

type T = ICompanySyncstep & IdName;

export class viewModel extends VariableAbstract<T> {
    protected routeId: TRouteId = 'syncstatusv2';
    protected serviceName: TServiceName = 'getcompanysyncsteps'

    constructor(protected override params: IVariableParams<T>) {
        super(params);
    }

    protected override getParams(): TServiceParameters {
        return {}
    }

    protected override getItemFromArray(data: T[]): T {
        if (data.length > 1) {
            if (this.params.id) {
                return data.find((item: T) => item.syncstep.id == this.id) ?? data[0]!;
            }
        }
        return super.getItemFromArray(data)
    }

    protected override onSuccess(item: TBaseOrObservableType<T>) {
        const value = getAnyValue(item);
        super.onSuccess({...value, name: nsSync.getSyncstepName(value.syncstep)} as T)
        this.isReady(false)
        this.name = nsSync.getSyncstepName(getAnyValue(this.item).syncstep)
        this.href = getHash(this.routeId, {companysyncstepid: getAnyValue(this.item).id}, true, this.params.orgnr) ?? null
        this.isReady(true)
    }

    protected override getTitle(): string {
        return nsTooltip.getTitle_companysyncstep(getAnyValue(this.item))
    }

}